import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing document signing information
 */
const create = () => {
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();

    const getSignedForms = () => api.get(ApiPaths.GET_SIGNED_DOCUMENTS);

    const getESignatureUriForAdditionalDocs = (taxYear, forms, isSpouse = false) => {
        var formData = forms.map(f => ({
            form_type: 'RetrieveFromCdm',
            form_name: f
        }))
        
        var payload = {
            forms: formData,
            isSpouse: isSpouse,
            taxYear: taxYear
        }
        return api.post(ApiPaths.SIGN_DOCUMENT, payload)
    }

    const getESignatureUri = (taxYear, forms, urls, isSpouse = false) => {
        var formData = []
        for (var i = 0; i < forms.length; ++i) {
            // VAI-458 certain forms will need to be signed from Box
            if (urls && (forms[i] === 'T183' || forms[i] === 'TP1000')) {
                formData.push({
                    form_type: 'RetrieveFromCdm',
                    form_name: forms[i],
                    document_id: urls[i]
                })
            } else {
                formData.push({
                    form_type: 'Fillable',
                    form_name: forms[i]
                })
            }
        }
        var payload = {
            forms: formData,
            isSpouse: isSpouse,
            taxYear: taxYear
        }
        return api.post(ApiPaths.SIGN_DOCUMENT, payload)
    }

    const completeForm = (envelopeId, recipientId) => {
        var payload = {
            envelopeId: envelopeId,
            recipientId: recipientId
        }
        return api.post(ApiPaths.COMPLETE_DOCUMENT_SIGNING, payload)
    }

    // Return back a collection of functions
    return {
        getESignatureUri, completeForm, getSignedForms, getESignatureUriForAdditionalDocs
    }
}

// let's return back our create method as the default.
export default {
    create
}

